<template>
  <MainTemplate>
    <div class="agent container">
      <router-view></router-view>
    </div>
  </MainTemplate>
</template>

<script>
import MainTemplate from '@/templates/MainTemplate.vue'
import i18nMessages from '@/translations/Agent/Index.i18n'

export default {
  name: 'Agent',
  components: { MainTemplate },
  i18n: { messages: i18nMessages },
  methods: { }
}
</script>
